import { render, staticRenderFns } from "./SMSTwilio.vue?vue&type=template&id=67f3588c&"
import script from "./SMSTwilio.vue?vue&type=script&lang=js&"
export * from "./SMSTwilio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports